<div class="manage-autopay-header">
  <div class="manage-autopay-header-title">
    {{ 'MANAGE_AUTOPAY' | translate }}
  </div> 
  <div class="manage-autopay-header-sub-title">
      {{'AUTOPAY_CONTENT' | translate }}
  </div>
</div>

<ng-container *ngIf="loading">
  <mapfre-loading></mapfre-loading>
</ng-container>
<ng-container *ngIf="!loading">  
  <app-manage-autopay-imp-notice *ngIf="showEnrollImpNotice"></app-manage-autopay-imp-notice>
  <app-imp-notice [theme]="'blue'" [impText]='twCCDCImpText' *ngIf="showTwCCDCImpNotice"></app-imp-notice>

  <section class="flex-column">
    <ng-container *ngIf="policyInfo?.length > 0">
      <ng-container *ngFor="let policy of policyInfo | sortByStatus : '-effDate'">
        <ng-container *ngIf="policy?.isAutoPayAvailable">
          <ng-container *ngIf="policy?.maBadCheck || policy?.isPendingStatus; else otherStatus">
            <div class="manage-ap-unav-pend-status">
              <div class="auto-pay-icon">
                <img 
                  *ngIf="!isAcmic"
                  src="{{policy?.displayType?.icon}}" 
                  width="32" height="32" 
                  alt="{{policy?.policyType?.toLowerCase()}} icon" 
                />
                <img 
                  *ngIf="isAcmic"
                  src="{{policy?.displayType?.icon}}" 
                  width="32" height="32" 
                  alt="{{policy?.policyType?.toLowerCase()}} icon" 
                />
              </div>

              <div class="policy-type-id policy-status">
                <div class="policy-info-autopay">
                <a [ngClass]="{'lh-20': !isAcmic}" class="nowrap autopay-paperless-policies" [routerLink]="['/my-insurance', policy?.policynumber.policyNumber , 'details']">
                  <span class="hide-policy-id-mobile">
                    {{ policy?.displayType?.label }} &ndash;
                  </span>
                  {{ policy?.policynumber.policyNumber }}
                </a>
                <span class="text-info-autopay-paperless margin-top mt-1">
                  {{ policy?.effDate | date:'MM/dd/yy' : 'shortDate' }}-{{ policy?.expDate | date:'MM/dd/yy' : 'shortDate' }}
                </span>
              </div>  
                <ng-container *ngIf="policy?.maBadCheck; else pendingStatus">
                  <div class="manage-ap-status-text">{{ 'NOT_AVAILABLE_FOR_AUTOPAY' | translate }}</div>
                </ng-container>

                <ng-template #pendingStatus>
                  <div class="enroll-button padding-right" *ngIf="policy?.policyFlags.isEft === 'ENROLLMENT-PENDING'">
                    <div class="manage-ap-status-text">{{'PENDING_ENROLLMENT' | translate}}</div>
                  </div>
                  <div class="enroll-button padding-right" *ngIf="policy?.policyFlags.isEft === 'UNENROLLMENT-PENDING'">
                    <div class="manage-ap-status-text">{{'PENDING_REMOVAL' | translate}}</div>
                  </div>
                  <div class="enroll-button padding-right" *ngIf="policy?.policyFlags.isEft === 'UPDATE-PENDING'">
                    <div class="manage-ap-status-text">{{'UPDATE_PENDING' | translate}}</div>
                  </div>
                </ng-template>
              </div>
            </div>
          </ng-container>
          <ng-template #otherStatus>
            <div class="align-items-center manage-autopay-policies-row">
              <div 
                class="d-flex items-start" 
                [ngClass]="{ 'align-items-center': (policy?.policyFlags?.isEft==='UNENROLLED' || policy?.policyFlags?.isEft==='FALSE')
                                      || (policy?.company.companyName === 'TW' || policy?.company.companyName === 'ACIC') }"
              >
                <div class="auto-pay-icon">
                  <img 
                    *ngIf="!isAcmic"
                    src="{{policy?.displayType?.icon}}" 
                    width="32" height="32" 
                    alt="{{policy?.policyType?.toLowerCase()}} icon" 
                  />
                  <img 
                    *ngIf="isAcmic"
                    src="{{policy?.displayType?.icon}}" 
                    width="32" height="32" 
                    alt="{{policy?.policyType?.toLowerCase()}} icon" 
                  />
                </div>

                <div class="policy-type-id d-flex flex-column">
                  <a [ngClass]="{'lh-20': !isAcmic}" class="nowrap autopay-paperless-policies" [routerLink]="['/my-insurance', policy?.policynumber.policyNumber , 'details']">
                    <span class="hide-policy-id-mobile">
                      {{ policy?.displayType?.label }} &ndash;
                    </span>
                    {{ policy?.policynumber.policyNumber }}
                  </a>
                  <span class="text-info-autopay-paperless margin-top mt-1">
                    {{ policy?.effDate | date:'MM/dd/yy' : 'shortDate' }}-{{ policy?.expDate | date:'MM/dd/yy' : 'shortDate' }}
                  </span>
                  <div 
                    *ngIf="!(policy?.policyFlags?.isEft==='UNENROLLED' || policy?.policyFlags?.isEft==='FALSE')"
                    class="manage-ap-type-info d-flex flex-column-autopay-mobile margin-top mt-1"
                  >
                    <ng-container 
                      *ngIf="(policy?.policyFlags.isEft === 'ENROLLED' || policy?.policyFlags?.isEft==='TRUE') 
                              && policy?.autoPayDetails?.cardType"
                    >
                      <span>
                        <payment-cc-dc-svg [type]="policy?.autoPayDetails?.cardType"></payment-cc-dc-svg>
                        <span class="text-info-autopay-paperless" >
                          {{' ending in '}} {{ policy?.autoPayDetails?.displayName | replaceString}}
                        </span>
                      </span>
                      <span class="text-info-autopay-paperless">
                        {{'Monthly charge date:'}} {{ policy?.autoPayDetails?.paymentDayOfMonth ?? (policy?.autoPayDetails?.deductionDay | extractDay) }}
                      </span>
                    </ng-container>
                    <ng-container 
                      *ngIf="(policy?.policyFlags.isEft === 'ENROLLED' || policy?.policyFlags?.isEft==='TRUE') 
                              && !policy?.autoPayDetails?.cardType 
                              && !(policy?.company.companyName==='TW' || policy?.company.companyName==='ACIC')"
                    >
                      <span class="text-info-autopay-paperless">
                        {{'Bank account ending in '}} {{ policy?.autoPayDetails?.bankAccount?.slice(-4) | replaceString}}
                      </span>
                      <span class="text-info-autopay-paperless deduction-date-text">
                      <span class="hyphen-separator">&nbsp;-&nbsp;</span>{{'Monthly deduction date:'}} {{ policy?.autoPayDetails?.paymentDayOfMonth ?? (policy?.autoPayDetails?.deductionDay | extractDay) }}
                      </span>
                    </ng-container>
                    <ng-container 
                      *ngIf="(policy?.policyFlags.isEft === 'ENROLLED' || policy?.policyFlags?.isEft==='TRUE') 
                              && policy?.company.companyName==='TW'"
                    >
                      <span class="text-info-autopay-paperless">
                        {{policy?.isTWRecurringCCDC 
                            ? 'Credit/debit card'
                            : 'Checking/savings'}}
                      </span>
                    </ng-container>
                  </div>
                </div>
            </div>

            <div class="w-100-mobile" *ngIf="(policy?.policyFlags?.isEft==='UNENROLLED' || policy?.policyFlags?.isEft==='FALSE')">
              <div class="manage-ap-policy-action-sec" *ngIf="isAcmic || policy?.company?.companyName === 'TW'">
                <div class="w-100-mobile">
                    <app-autopay-enroll-modal 
                      [policy]="policy" [action]="'enroll'" 
                      (enrollEvent)="enrollInAutopay(policy, 'ENROLL', $event)"
                      *ngIf="isAcmic"
                    >
                    </app-autopay-enroll-modal>
                    <app-autopay-payment-method-modal 
                      [policy]="policy" 
                      (enrollEvent)="enrollInAutopay(policy, 'ENROLL', $event)"
                      *ngIf="policy?.company?.companyName === 'TW'"
                    >
                    </app-autopay-payment-method-modal>
              </div>
            </div>
            <div 
              class="autopay-learn-more manage-ap-policy-action-sec mobile-reverse" 
              *ngIf="policy?.billingDetails[0]?.badCheckCount==='N' && policy?.billingDetails[0]?.mortageeFlag==='N' 
                        && !isAcmic && policy?.company?.companyName !== 'TW'"
            >
              <a 
                routerLink="/faq/autopay" 
                class="learn-more-link dm-sans-medium" 
                *ngIf="policy?.company?.companyName === 'MA' || policy?.policynumber.policyNumber.length === 6"
              >
                {{ "Learn more" | translate }}
              </a>
              <div class="w-100-mobile">
                <mapfre-button 
                  (click)="enrollInAutopay(policy, 'ENROLL')" 
                  [additionalClasses]="'basic primary x-small-btn manage-ap-btn enroll-ap-btn'" 
                  [translateValue]=" 'ENROLL_NOW' | translate "
                >
                  {{ 'ENROLL' | translate }}
                </mapfre-button>
              </div>
            </div>
          </div>

              <!-- Edit autopay -->
              <div 
                class="d-flex align-items-center manage-ap-policy-action-sec" 
                *ngIf="(policy?.policyFlags.isEft === 'ENROLLED' || policy?.policyFlags?.isEft==='TRUE')"
              >
                <ng-container *ngIf="!isAcmic && !policy?.isTWRecurringCCDC">
                  <div class="w-100-mobile">
                    <mapfre-button 
                      (click)="enrollInAutopay(policy, 'UPDATE')"
                      additionalClasses="btn mapfre ghost secondary x-small-btn manage-ap-btn edit-ap-btn" 
                      [translateValue]=" 'EDIT' | translate "
                    >
                      {{ 'EDIT' | translate }}
                    </mapfre-button>
                  </div>
                </ng-container>

                <div class="w-100-mobile" *ngIf="isAcmic">     
                  <app-autopay-enroll-modal 
                      [policy]="policy" [action]="'edit'" 
                      (enrollEvent)="enrollInAutopay(policy, 'UPDATE')"
                    >
                  </app-autopay-enroll-modal>       
                </div>

                <div class="w-100-mobile" *ngIf="policy?.isTWRecurringCCDC">
                  <app-autopay-unenrolled-preconfirm 
                    [policy]="policy"
                    [action]="'edit'"
                    (unenrollEvent)="cancelAutopay(policy, 'e-pay', 'unenrollToEdit')">                  
                  </app-autopay-unenrolled-preconfirm>
                </div>

              <div class="w-100-mobile">
                <app-autopay-unenrolled-preconfirm 
                  [policy]="policy" 
                  (unenrollEvent)="cancelAutopay(policy, 'e-pay')">                  
                </app-autopay-unenrolled-preconfirm>
              </div>
                <mapfre-button 
                  *ngIf="(policy?.days_left_to_expire <= 30 && policy?.policynumber.policyNumber.length === 6) || policy.isNewPolicy" 
                  (click)="cancelAutopay(policy, 'e-pay')" 
                  additionalClasses="btn mapfre ghost secondary x-small-btn"
                >
                    {{ 'UNENROLL' | translate }}
                  </mapfre-button>
              </div>
            </div>
          </ng-template>
        </ng-container>
      </ng-container>
    </ng-container>    
  </section>
</ng-container>
<div class="row margin-top mt24 text-center checkingrowbtm h-24">
  <div class="col h-24">
    <ng-container *ngIf="isAcmic; else maStateBackbtn">
        <mapfre-button
          (click)="navService.navigateBack()"
          additionalClasses="link-button blue-color-link top-information no-padding font-weight-normal h-24"
          [backIcon]="'assets/img/images/icon-strong-arrow-left-autopay.svg'"
          [iconClasses]="'align-middle back-arrow-icon'"
          [showIconsCustom]="true"
        > 
          {{ 'Back' | translate }}
        </mapfre-button>
    </ng-container>
    <ng-template #maStateBackbtn>
      <mapfre-button
        (click)="navService.navigateBack()"
        additionalClasses="link-button red-link top-information no-padding button-border-red font-weight-500"
        [backIcon]="'assets/img/icons/back-arrow-red.svg'" 
        [iconClasses]="'align-middle pr-1'"
        [showIconsCustom]="true"
      > 
        <span>{{ 'BACK' | translate }}</span>
      </mapfre-button>
    </ng-template>
  </div>
</div>
